import React from 'react';
import PropTypes from 'prop-types';
import colors from 'customizations/js/color-variables';

export const IconDesktopSearch = ({ className, color }) => (
  <svg className={className} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M23.8112 11.5324C23.8112 17.4292 19.0309 22.2095 13.1341 22.2095C10.7892 22.2095 8.62096 21.4537 6.85957 20.1723L2.63846 24.3934C2.16953 24.8623 1.40925 24.8623 0.94032 24.3934C0.471391 23.9245 0.471391 23.1642 0.94032 22.6953L5.08627 18.5493C3.4488 16.6729 2.45693 14.2184 2.45693 11.5324C2.45693 5.63555 7.23725 0.855225 13.1341 0.855225C19.0309 0.855225 23.8112 5.63555 23.8112 11.5324ZM21.4097 11.5324C21.4097 16.1029 17.7046 19.808 13.1341 19.808C8.56359 19.808 4.85847 16.1029 4.85847 11.5324C4.85847 6.96188 8.56359 3.25676 13.1341 3.25676C17.7046 3.25676 21.4097 6.96188 21.4097 11.5324Z" fill={color} stroke={color} strokeWidth="0.2" strokeLinecap="round" />
  </svg>
);

IconDesktopSearch.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

IconDesktopSearch.defaultProps = {
  className: '',
  color: colors.gray40
};
